import { ExclamationCircleOutlined } from "@ant-design/icons";
import { Spacer } from "views/components/common/Spacer";
import { Typography } from "antd";
import { WizzardButton } from "views/components/WizzardButton";
import { Wrapper } from "./styles";
import React from "react";
import i18next from "i18next";

const { Title } = Typography;

const modalType = {
	reservationCancel: {
		icon: (
			<ExclamationCircleOutlined
				style={{ fontSize: 32, color: "#ff4d4f" }}
			/>
		),
		title: i18next.t("booking:modalCancelBookingTitlePrimary"),
		description: i18next.t("booking:modalCancelBookingDescriptionPrimary"),
		buttonLabel: i18next.t("booking:modalCancelBookingActionAcceptPrimary"),
		onClickButton: true,
		cancelButtonLabel: i18next.t(
			"booking:modalCancelBookingActionCancelPrimary"
		),
	},
	"new-alert": {
		icon: (
			<ExclamationCircleOutlined
				style={{ fontSize: 32, color: "#ff4d4f" }}
			/>
		),
		title: i18next.t("booking:modalCancelBookingTitleSecondary"),
		description: i18next.t(
			"booking:modalCancelBookingDescriptionSecondary"
		),
		buttonLabel: i18next.t(
			"booking:modalCancelBookingActionAcceptSecondary"
		),
		onClickButton: false,
		cancelButtonLabel: i18next.t(
			"booking:modalCancelBookingActionCancelSecondary"
		),
	},
	"block-already-taken-error": {
		icon: (
			<ExclamationCircleOutlined
				style={{ fontSize: 32, color: "#ff4d4f" }}
			/>
		),
		title: i18next.t("booking:modalBlockAlreadyTakenTitle"),
		description: "",
		buttonLabel: i18next.t(
			"booking:modalBlockAlreadyTakenAction"
		),
		onClickButton: false,
		cancelButtonLabel: i18next.t(
			"booking:modalBlockAlreadyTakenCancel"
		),
		
	},
	"generic-error": {
		icon: (
			<ExclamationCircleOutlined
				style={{ fontSize: 32, color: "#ff4d4f" }}
			/>
		),
		title: i18next.t("booking:modalCancelBookingTitleSecondary"),

		buttonLabel: i18next.t(
			"booking:modalCancelBookingActionAcceptSecondary"
		),
		onClickButton: false,
		cancelButtonLabel: i18next.t(
			"booking:modalCancelBookingActionCancelSecondary"
		),
	},
	"new-alert-error": {
		icon: (
			<ExclamationCircleOutlined
				style={{ fontSize: 32, color: "#ff4d4f" }}
			/>
		),
		title: i18next.t("booking:modalCancelBookingTitleSecondary"),
		buttonLabel: i18next.t(
			"booking:modalCancelBookingActionAcceptSecondary"
		),
		onClickButton: false,
		cancelButtonLabel: i18next.t(
			"booking:modalCancelBookingActionCancelSecondary"
		),
	},
	"already-has-a-ticket": {
		icon: (
			<ExclamationCircleOutlined
				style={{ fontSize: 32, color: "#ff4d4f" }}
			/>
		),
		title: "Ya te uniste a una fila en esta sucursal ",
		description:
			"Debes esperar a que te llamen para solicitar un nuevo ticket",
		onClickButton: false,
		cancelButtonLabel: "Entendido",
	},
};

export const GenericModal = ({
	visible,
	type,
	onClick,
	onCancel,
	loading,
	description,
}) => {
	return (
		<Wrapper visible={visible} footer={false} onCancel={onCancel}>
			<div>{modalType[type].icon}</div>
			<Spacer rows={0.5} />
			<Title level={5}>
				{description ? description : modalType[type].title}
			</Title>
			<div>{modalType[type].description}</div>
			<div className={"button_container"}>
				<Spacer rows={0.5} />
				{modalType[type].onClickButton && (
					<WizzardButton
						type={"genericModalPrimary"}
						label={modalType[type].buttonLabel}
						size={"100%"}
						onClick={onClick}
						loading={loading}
						disabled={loading}
					/>
				)}
				{type !== "reservationCancel" ? (
					<Spacer rows={1} />
				) : (
					<Spacer rows={0.5} />
				)}
				<WizzardButton
					type={"backgroundless"}
					label={modalType[type].cancelButtonLabel}
					size={"100%"}
					onClick={onCancel}
				/>
			</div>
		</Wrapper>
	);
};
